// src/RouteChangeTracker.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { pageview } from "./gtag"; // your GA utility function

const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    pageview(location.pathname);
  }, [location]);

  return null;
};

export default RouteChangeTracker;
